import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=7acc4212&scoped=true"
import script from "./ThankYou.vue?vue&type=script&lang=ts"
export * from "./ThankYou.vue?vue&type=script&lang=ts"
import style0 from "./ThankYou.vue?vue&type=style&index=0&id=7acc4212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acc4212",
  null
  
)

export default component.exports